"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchResults = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _QuestionItem = require("../QuestionItem/QuestionItem");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchResults = ()=>{
    const { translations } = (0, _hooks.useTranslations)();
    const { searchQuestions, totalCount, showMore } = (0, _contexts.useSearchResultContext)();
    const { getTestId } = (0, _testidGenerator.default)();
    const renderButton = ()=>{
        if (totalCount > _constants.MAX_AMOUNT_ITEMS_TO_RENDER && searchQuestions.length < totalCount) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Button, {
                type: "button",
                onClick: showMore,
                children: translations.showMore
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId('search-results'),
        children: [
            searchQuestions.map((questionItem)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_QuestionItem.QuestionItem, {
                    questionItem: questionItem,
                    truncate: undefined
                }, questionItem.question)),
            renderButton()
        ]
    });
};
exports.SearchResults = SearchResults;
